import { render, staticRenderFns } from "./RailwayListShow.vue?vue&type=template&id=5623df40&scoped=true&"
import script from "./RailwayListShow.vue?vue&type=script&lang=js&"
export * from "./RailwayListShow.vue?vue&type=script&lang=js&"
import style0 from "./RailwayListShow.vue?vue&type=style&index=0&id=5623df40&lang=scss&scoped=true&"
import style1 from "./RailwayListShow.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5623df40",
  null
  
)

export default component.exports